export default __webpack_public_path__ + "static/holidayModal-cd5a55ca151de0be97bef92883b72a78.jpeg";